import { Injectable } from '@angular/core';
import { IExcel } from 'src/app/models/actualizarExcel';
import { IApiResponseExcel } from 'src/app/models/response/api';
import { CustomHttpService } from 'src/app/services/http/custom-http.service';


@Injectable()
export class TabledateService {
  private url: string = '/recargas';
  constructor(
      private _http: CustomHttpService
  ) { }

  async postUpdateExcelArray(data: IExcel[]): Promise<any> {
      const res = await this._http.post<IApiResponseExcel, IExcel[]>(
        this.url.concat(`/actualizarExcel`), data
      );
      console.log("reeeeeeeeeeeeeeeeeeeeeeeees", res);
    return res;
  }
}


